/**
 *  All api related to classes
 */

import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchClasses(options = {}) {
  const { page = 1, ...others } = options
  const params = {
    page,
    ...others
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchClasses',
    () => source.cancel('fetchClasses: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: 'sku_sku_quotas',
      method: 'get',
      params,
      type: 'skuQuota',
      cancelToken: source.token,
      arrayFormat: 'brackets',
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      skuSkuQuotas: _.get(data, 'skuSkuQuotas', {}),
      next: _.get(data, 'skuSkuQuotasPagination.nextPage') > page
        ? () =>
          fetchClasses({
            page: page + 1,
            ...others
          })
        : null,
      all: page === 1 && _.get(data, 'skuSkuQuotasPagination.nextPage') > 1
        ? () => Promise.all(
          _.times(
            _.get(data, 'skuSkuQuotasPagination.totalPages') - 1,
            (index) => fetchClasses({
              pageCountless: true,
              page: index + 2,
              ...others
            }),
          ),
        )
        : null,
      count: _.get(data, 'skuSkuQuotasPagination.totalCount'),
    }))
}
